import * as css from "./style.css";
import { ReactNode } from "react";

export function SubtleHeading(props: { children: ReactNode }) {
  return <h2 className={css.heading}>{props.children}</h2>;
}
